import { render, staticRenderFns } from "./VanFieldCheckbox.vue?vue&type=template&id=009f00a8&scoped=true&"
import script from "./VanFieldCheckbox.vue?vue&type=script&lang=js&"
export * from "./VanFieldCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./VanFieldCheckbox.vue?vue&type=style&index=0&id=009f00a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009f00a8",
  null
  
)

export default component.exports